var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdsObjectiveProduct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_10505_56266)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 48,
    height: 48,
    rx: 12,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 1.5,
    width: 47,
    height: 47,
    rx: 11.5,
    stroke: "#F9ED33",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0003 26.5163C25.8486 26.5163 25.6969 26.4813 25.5569 26.3997L15.2553 20.438C14.8469 20.193 14.6953 19.6563 14.9403 19.2363C15.1853 18.8163 15.7219 18.6763 16.1419 18.9213L26.0003 24.6263L35.8003 18.9563C36.2203 18.7113 36.7569 18.863 37.0019 19.2713C37.2469 19.6913 37.0953 20.228 36.6869 20.473L26.4553 26.3997C26.3036 26.4697 26.1519 26.5163 26.0003 26.5163Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 37.0856C25.5217 37.0856 25.125 36.6889 25.125 36.2106V25.6289C25.125 25.1506 25.5217 24.7539 26 24.7539C26.4783 24.7539 26.875 25.1506 26.875 25.6289V36.2106C26.875 36.6889 26.4783 37.0856 26 37.0856Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9998 37.5404C24.9731 37.5404 23.9581 37.3187 23.1531 36.8754L16.9231 33.4104C15.2314 32.477 13.9131 30.2254 13.9131 28.2887V21.697C13.9131 19.7604 15.2314 17.5204 16.9231 16.5754L23.1531 13.122C24.7514 12.2354 27.2481 12.2354 28.8464 13.122L35.0764 16.587C36.7681 17.5204 38.0864 19.772 38.0864 21.7087V28.3004C38.0864 30.237 36.7681 32.477 35.0764 33.422L28.8464 36.8754C28.0414 37.3187 27.0264 37.5404 25.9998 37.5404ZM25.9998 14.207C25.2648 14.207 24.5414 14.3587 24.0048 14.6504L17.7748 18.1154C16.6548 18.7337 15.6631 20.4137 15.6631 21.697V28.2887C15.6631 29.572 16.6548 31.252 17.7748 31.882L24.0048 35.347C25.0664 35.942 26.9331 35.942 27.9948 35.347L34.2248 31.882C35.3448 31.252 36.3364 29.5837 36.3364 28.2887V21.697C36.3364 20.4137 35.3448 18.7337 34.2248 18.1037L27.9948 14.6387C27.4581 14.3587 26.7348 14.207 25.9998 14.207Z",
    fill: "#292D32"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10505_56266",
    x: 0,
    y: 0,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10505_56266"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10505_56266",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdsObjectiveProduct);
export default __webpack_public_path__ + "static/media/ads-objective-product.6d3c86a5391cb318aeee0078ca3f6302.svg";
export { ForwardRef as ReactComponent };